import { render } from "./HomeNews.vue?vue&type=template&id=a5bca778&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=js"
export * from "./HomeNews.vue?vue&type=script&lang=js"

import "./HomeNews.vue?vue&type=style&index=0&id=a5bca778&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5bca778"

export default script